jQuery(document).ready(function($){

  $(".product_quote_button").insertAfter("terms-conditions");
  
  $(document).ajaxComplete(function(){
  $(".product_quote_button").insertAfter("terms-conditions");
});
})



// document.getElementById('add-to-quote').addEventListener('click', function() {







  
//     // Get product variant ID (assuming a hidden input field with the variant ID exists)
//     var variantId = document.querySelector('input[name="id"]').value;

//     // Add product to the cart via AJAX
//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//             items: [{ id: variantId, quantity: 1 }]
//         })
//     })
//     .then(response => response.json())
//     .then(data => {
//         // Redirect to cart page after the product is added
//         window.location.href = "/cart";
//     })
//     .catch(error => {
//         console.error('Error adding product to cart:', error);
//     });
// });





  // Add to quote

// document.getElementById('add-to-quote').addEventListener('click', function() {
//     const productTitle = "{{ product.title }}";
//     const productHandle = "{{ product.handle }}";
//     const productPrice = "{{ product.price | money }}";
//     const productURL = "{{ shop.url }}/products/{{ product.handle }}";

//     const quoteItem = {
//         title: productTitle,
//         handle: productHandle,
//         price: productPrice,
//         url: productURL
//     };

//     let quoteItems = JSON.parse(localStorage.getItem('quoteItems')) || [];
//     quoteItems.push(quoteItem);
//     localStorage.setItem('quoteItems', JSON.stringify(quoteItems));

//     window.location.href = "/pages/get-quote";
// });


// document.addEventListener("DOMContentLoaded", function() {
//     const addToQuoteButton = document.getElementById('add-to-quote');
//     const quoteIcon = document.getElementById('quote-icon');
//     let quoteList = JSON.parse(localStorage.getItem('quoteList')) || [];

//     function updateQuoteIcon() {
//         quoteIcon.textContent = quoteList.length;
//     }

//     addToQuoteButton.addEventListener('click', function() {
//         const productId = Shopify.product.id;
//         const productTitle = Shopify.product.title;
//         const productImage = Shopify.product.featured_image;
//         const productUrl = window.location.href;

//         if (!quoteList.some(item => item.id === productId)) {
//             quoteList.push({
//                 id: productId,
//                 title: productTitle,
//                 image: productImage,
//                 url: productUrl
//             });
//             localStorage.setItem('quoteList', JSON.stringify(quoteList));
//         }
//         updateQuoteIcon();
//         window.location.href = '/pages/get-quote';
//     });

//     updateQuoteIcon();
// });


  // end add to quote


